<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="isModalOpen" class="fixed top-0 left-0 p-15 w-full h-full bg-backdrop flex justify-center items-center z-50"
           @click.self="close"
      >
        <div class="relative bg-primary max-w-420 w-full rounded-4 p-20">
          <div class="text-app-color">
            <p class="text-22 font-black">Send to mail</p>
            <p class="text-14 mt-3 max-w-full">Send the document to any mail address. Seperate emails with a comma for multiple addresses.</p>

            <div class="mt-20 mb-25">
              <InputModule
                v-model="email"
                type="email"
                class="max-w-full"
                placeholder="ivyhello@gmail.com"
                input-classes="px-22 py-11 text-15"
                :error-message="error"
                @keypress.enter="send"
                @clearErrorMessage="error = null"
              />
            </div>
          </div>
          <div class="flex justify-end items-center">
            <ButtonModule
              text="Cancel"
              :has-hover="true"
              class="text-app-color text-15 mr-12"
              @click="close"
            />
            <ButtonModule
              text="Send"
              class="bg-link-color rounded-4 px-35 py-12 text-white text-15 "
              @click="send"
            />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import { preventBodyScroll, generateHTML } from '@/core/helper-functions'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import InputModule from '@/components/shared/form-controls/InputModule'
import { projectService } from '@/services'
import { emailValidation } from '@/helpers'
import localStorageService from '@/core/local-storage'

export default defineComponent({
  components: { ButtonModule, InputModule },

  props: {
    project: {
      type: Object,
      default: () => {}
    }
  },

  setup (props) {
    const route = useRoute()
    const { state, dispatch, commit } = useStore()

    const isModalOpen = ref(false)
    const email = ref(localStorageService.getItem('sendTo') || '')
    const error = ref(null)

    const settings = computed(() => state.settings.settings)
    const share = computed(() => state.project.share)

    function open () {
      preventBodyScroll(true)
      isModalOpen.value = true
    }

    function close () {
      preventBodyScroll(false)
      isModalOpen.value = false
    }

    function send () {
      localStorageService.setItem('sendTo', email.value)

      if (!error.value) {
        error.value = emailValidation(email.value)
      }

      if (!error.value && email.value.trim() !== '') {
        if (route.name === 'Share') {
          projectService.sendShared({ email: email.value, projectId: props.project.id, shareId: share.value.id })
            .then(() => {
              commit('setNotification', { isVisible: true, message: 'Page was successfully sent', color: '' })
              close()
            }).catch(() => close())
        } else {
          // rerender html and send to email
          dispatch('editProject', {
            id: props.project.id,
            data: {
              title: props.project.title,
              html: generateHTML(props.project.body, settings.value, props.project.title)
            }
          }).then(() => {
            projectService.send({ email: email.value, projectId: props.project.id })
              .then(() => {
                commit('setNotification', { isVisible: true, message: 'Page was successfully sent', color: '' })
                close()
              }).catch(() => close())
          })
        }
      }
    }

    return {
      // ref
      isModalOpen,
      email,
      error,
      // computed
      settings,
      share,
      // function
      open,
      close,
      send
    }
  }
})
</script>
